import { parseJSON } from "date-fns";
import instance from "../axiosConfig";
import { ElementVersions, Version } from "./models";
import { VersionResponse } from "./models/VersionResponse";

export class VersionService {
    private regionCode: string;
    private languageCode: string;

    constructor(regionCode: string, languageCode: string) {
        this.regionCode = regionCode;
        this.languageCode = `${regionCode}-${languageCode}`;
    }

    static get = async (): Promise<Array<Version>> => {
        const response = await instance.get<Array<VersionResponse>>(`api/versions`);
        const data = response.data.map((version) => ({
            ...version,
            publicationDate: parseJSON(version.publicationDate),
        }));

        return data.sort((a, b) => a.publicationDate.getTime() - b.publicationDate.getTime());
    };

    getElementVersions = async (slug: string): Promise<ElementVersions> => {
        const response = await instance.get<ElementVersions>(
            `/api/versions/regions/${this.regionCode}/languages/${this.languageCode}/elements/${slug}`
        );

        return response.data;
    };
}
